import type { Dispatch, SetStateAction } from 'react';
import type { FormSegment } from '../../../../../../../../../modules/audiences/AudienceForm/types';

export const createSegmentDeleteHandler = (
  segments: FormSegment[],
  setSegments: Dispatch<SetStateAction<FormSegment[]>>
) => {
  return (segmentToRemove: FormSegment) => {
    const updatedSegments = segments.filter(segment => segment.id !== segmentToRemove.id);
    setSegments(updatedSegments);
  };
};
